import React, { useState, useEffect } from 'react';
// <SeasonIcon date={date} />


function SeasonIcon(props) {
  const [seasonData, setSeasonData] = useState({data:[], isLoading:true, error:null});

  useEffect(() => {
    fetchSeasonData();
 }, []);
  
         

   // Fetch Season data 

  const fetchSeasonData = async () => {
      setSeasonData({
        ...seasonData,
        isLoading: true
      })
    try {
      const response = await fetch(`https://aa.usno.navy.mil/api/seasons?year=${props.currentDate.getFullYear()}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      setSeasonData({ data: data.data, isLoading: false, error: null });
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Unknown error';
      setSeasonData({ data: null, isLoading: false, error: errorMessage });
    }
  };
 

  
  const getSeasonIcon = (date) => {
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const seasons = seasonData.data
      const foundSeason = seasons?.find((season) => season.month === month && season.day === day);
      if (foundSeason) {
      if (foundSeason.phenom === 'Perihelion') return 'Perihelion'
      if (foundSeason.phenom === 'Equinox') return 'Equinox'
      if (foundSeason.phenom === 'Solstice') return 'Solstice'
      if (foundSeason.phenom === 'Aphelion') return 'Aphelion'
    }
  };


  return (
    <>
    {!seasonData.isLoading &&
     <span className="text-xs">{getSeasonIcon(props.date)} </span>
    }
    </>
  )
}

export default SeasonIcon